import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToc24PxOutlined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "toc_24px",
		children: /* @__PURE__ */ _jsx("path", {
			id: "icon/action/toc_24px",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7 15H21V17H7V15ZM7 11H21V13H7V11ZM21 7H7V9H21V7ZM3 7H5V9H3V7ZM5 17V15H3V17H5ZM3 11H5V13H3V11Z",
			fill: "currentColor"
		})
	})]
});
const ForwardRef = forwardRef(SvgToc24PxOutlined);
export default ForwardRef;
